/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для подарков за действие в корзине
   */
  app.GiftsForActionsView = app.View.extend({
    el: '#gifts-for-actions',
    views: [],
    run: function () {
      this.listenTo(this.cart, 'sync', this.render);
    },
    render: function () {
      var that = this;
      this.$el.html('');
      _.each(this.cart.giftsForActions, function (item) {
        var giftView = new app.GiftForActionItemView({
          model: item,
        });
        that.views.push(giftView);
        that.$el.append(giftView.render().el);
      });
    },
  });
})();

}.call(window));